<template>
  <div>
    <h2>比赛</h2>

    <Divider>计划</Divider>

    <Table class="table" :columns="col1" :data="planData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="date">
        <span
          >{{ $moment(row.startTime).format("YYYY/MM/DD") }} -
          {{ $moment(row.endTime).format("YYYY/MM/DD") }}</span
        >
      </template>

      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
        <i-button
          type="success"
          size="small"
          style="margin-left: 5px"
          @click="setHistory(row)"
          >设为历史</i-button
        >
      </template>
    </Table>

    <Button type="dashed" class="add-btn" @click="edit({})">添加</Button>

    <Divider>历史</Divider>
    <Table class="table" :columns="col2" :data="historyData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="date">
        <span
          >{{ $moment(row.startTime).format("YYYY/MM/DD") }} -
          {{ $moment(row.endTime).format("YYYY/MM/DD") }}</span
        >
      </template>

      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
      </template>
    </Table>

    <Modal
      v-model="showEdit"
      title="计划添加/修改"
      @on-ok="save"
      @on-cancel="showEdit = false"
    >
      <Form :model="editObj" label-position="left" :label-width="100">
        <FormItem label="时间">
          <DatePicker
            :value="[editObj.startTime, editObj.endTime]"
            format="yyyy-MM-dd"
            @on-change="changeDate"
            type="daterange"
            placement="bottom-end"
            placeholder="选择竞赛时间"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="Name">
          <i-input type="text" v-model="editObj.name"></i-input>
        </FormItem>
        <FormItem label="Level">
          <i-input type="text" v-model="editObj.level"></i-input>
        </FormItem>
        <FormItem label="Expected Honor">
          <i-input type="text" v-model="editObj.expected_honor"></i-input>
        </FormItem>
        <FormItem label="Honor">
          <i-input type="text" v-model="editObj.honor"></i-input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      planData: {},
      historyData: {},
      col1: [
        {
          title: "No.",
          slot: "number",
          align: "center",
        },
        {
          title: "Date",
          slot: "date",
          align: "center",
        },
        {
          title: "Name",
          key: "name",
          align: "center",
        },
        {
          title: "Level",
          key: "level",
          align: "center",
        },
        {
          title: "Expected Honor",
          key: "expected_honor",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      col2: [
        {
          title: "No.",
          slot: "number",
          align: "center",
        },
        {
          title: "Date",
          slot: "date",
          align: "center",
        },
        {
          title: "Name",
          key: "name",
          align: "center",
        },
        {
          title: "Level",
          key: "level",
          align: "center",
        },
        {
          title: "Honor",
          key: "honor",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      showEdit: false,
      editObj: {},
    };
  },
  methods: {
    async getPlanData(page = 1) {
      let res = await this.api({
        url: "/competition/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 0,
        },
      });

      this.planData = res;
    },
    async getHistoryData(page = 1) {
      let res = await this.api({
        url: "/competition/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 1,
        },
      });

      this.historyData = res;
    },

    edit(val) {
      this.editObj = val;
      this.showEdit = true;
    },
    async save() {
      await this.api({
        url: "/competition/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editObj,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });
      this.$Message.success("更新成功");
      this.showEditPlan = false;
      this.getPlanData();
      this.getHistoryData();
    },

    async setHistory(val) {
      await this.api({
        url: "/competition/setHistory",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          _id: val._id,
        },
      });

      this.$Message.success("更新成功");
      this.getPlanData();
      this.getHistoryData();
    },

    changeDate(val) {
      this.editObj.startTime = val[0];
      this.editObj.endTime = val[1];
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getPlanData();
    this.getHistoryData();
  },

  watch: {
    "$store.getters.selectedStudent": function () {
      this.getPlanData();
      this.getHistoryData();
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>